import React, { useEffect, useRef, useState } from 'react'

import BackButton from './BackButton'
import UtilityLogo from './UtilityLogo'
import Freddie from './Freddie'

import './UtilityNav.css';

const UtilityNav = () => {
  const offsetYRef = useRef(0)
  const headerRef = useRef(null)
  const [isMinified, setMinified] = useState(false)
  const [isScrollingDown, setScrollingDown] = useState(false)

  const handleScroll = () => {
    const currentOffsetY = window.pageYOffset
    if (currentOffsetY > 0) {
      setMinified(true)
      setScrollingDown(currentOffsetY > offsetYRef.current)
    } else {
      setMinified(false)
    }

    offsetYRef.current = currentOffsetY
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [isScrollingDown, isMinified])

  return (
    <>
      <div ref={headerRef} className="utility_nav">
        <div className="utility_nav__container">
          <a href="https://mailchimp.com/">
            <div className="logo_button">
              <BackButton />
              <Freddie />
              <UtilityLogo />
            </div>
          </a>
        </div>
      </div>
    </>
  )
}

export default UtilityNav
